/**
 * @desc 订单分页接口
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.ComeOnStatisticalQueryParameters>): Promise<BaseResponse<defs.PageBean<Array<defs.TheReconciliationSubsidiaryEntities>>>> {
  return fetch({
    url: config.API_HOST + '/statistics/supplementOrderApplyList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
